import { useCallback } from 'react';
import { ROUTE_CREATE_CRITERIA } from '@/constants/routes';
import { push } from 'redux-first-router';
import { getPath } from '@/router/utils';

export const useReduxForDashboard = () => {
  const navigateToScreener = useCallback(
    (marketISO?: string, industrySlug?: string) => {
      if (typeof marketISO === 'undefined') return;
      const safeIndustrySlug =
        industrySlug !== 'any' ? industrySlug : undefined;
      const path = getPath({
        type: ROUTE_CREATE_CRITERIA,
        payload: { marketISO, industrySlug: safeIndustrySlug },
      });
      push(path);
    },
    []
  );

  return {
    navigateToScreener,
  };
};
